import '@fontsource/noto-sans/cyrillic-400.css';
import '@fontsource/noto-sans/cyrillic-500.css';
import '@fontsource/noto-sans/cyrillic-600.css';
import '@fontsource/noto-sans/cyrillic-700.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import './index.css';
import {AuthLayout} from './layouts/AuthLayout/AuthLayout';
import Landing from './pages/Auth/Landing/Landing';
import Login from './pages/Auth/Login/Login';
import {AdminLayout} from './layouts/AdminLayout/AdminLayout';
import PrivateRoute from './helpers/PrivateRoute';
import {Users} from './pages/Admin/Users/Users';
import {Workplaces} from './pages/Admin/Workplaces/Workplaces';
import {Education} from './pages/Admin/Education/Education';
import {SIZ} from './pages/Admin/SIZ/SIZ';
import {Deadlines} from './pages/Admin/Deadlines/Deadlines';
import {Documents} from './pages/Admin/Documents/Documents';
import {Downloads} from './pages/Admin/Downloads/Downloads';

const router = createBrowserRouter([
	{
		path: '/',
		element: <AuthLayout/>,
		children: [
			{ index: true, element: <Landing /> },
			{ path: 'login', element: <Login /> }
		]
	},
	{
		path: '/admin',
		element: <PrivateRoute adminOnly><AdminLayout/></PrivateRoute>,
		children: [
			{ index: true, element: <Users/> },
			{ path: 'users', element: <Users/> },
			{ path: 'workplaces', element: <Workplaces/> },
			{ path: 'education', element: <Education/> },
			{ path: 'SIZ', element: <SIZ/> },
			{ path: 'deadlines', element: <Deadlines/> },
			{ path: 'documents', element: <Documents/> },
			{ path: 'downloads', element: <Downloads/> }
		]
	}
]);

// CRA error overlay treats benign Recharts/Ant ResizeObserver loop noise as a crash.
// Same message is ignored in Cypress (cypress/support/e2e.js).
window.addEventListener('error', (event) => {
	if (event.message?.includes('ResizeObserver loop')) {
		event.stopImmediatePropagation();
	}
}, true);

ReactDOM.render(
	<React.StrictMode>
		<RouterProvider router={router}/>
	</React.StrictMode>,
	document.getElementById('root')
);